import script from "./help_detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./help_detail.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__